"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3515],{

/***/ 93515:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var isomorphic_dompurify__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(29238);
/* harmony import */ var isomorphic_dompurify__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(isomorphic_dompurify__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _context_HeaderFooterContext__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2621);




var CopyRightComponent = function() {
    var ref, ref1;
    var headerFooterData = (0,react__WEBPACK_IMPORTED_MODULE_2__.useContext)(_context_HeaderFooterContext__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP);
    var headerFooter = headerFooterData.headerFooter;
    var copyRight = (ref = headerFooter[0]) === null || ref === void 0 ? void 0 : (ref1 = ref.attributes) === null || ref1 === void 0 ? void 0 : ref1.Copyright;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "copyrights",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "container",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                dangerouslySetInnerHTML: {
                    __html: isomorphic_dompurify__WEBPACK_IMPORTED_MODULE_1___default().sanitize(copyRight)
                }
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (CopyRightComponent);


/***/ })

}]);